import { z } from "zod";

export const PROTOCOL_VERSION = 19;
export const CLIENT_PROTOCOL_HEADER = "x-frontier-protocol";
export const CLIENT_PROTOCOL_HEADERS = {
  [CLIENT_PROTOCOL_HEADER]: String(PROTOCOL_VERSION),
};
export const CLIENT_UPDATE_REQUIRED = "CLIENT_UPDATE_REQUIRED";
export const CLIENT_UPDATE_MESSAGE =
  "Игра обновилась. Перезагрузите страницу, чтобы продолжить. Прогресс сохранён.";
export const clientProtocolSchema = z.object({
  protocolVersion: z.literal(PROTOCOL_VERSION),
});
